import { Injectable } from '@angular/core'
import { ColorPreferences } from '@app/models/color-preferences'
import { abbreviate } from '@app/utils/abbreviate'
import { State, Action, StateContext, Selector } from '@ngxs/store'
import { UserAction } from './user.actions'

export interface UserStateModel {
	// TODO: add to models
	colorPreference: ColorPreferences
	email: string
	firstName: string
	lastName: string
	headshot: string
	initials: string
	fullName: string
	crmUserId: string
}

const defaults: UserStateModel = {
	colorPreference: ColorPreferences.Teal,
	email: '',
	firstName: '',
	lastName: '',
	headshot: '',
	initials: '',
	fullName: '',
	crmUserId: '',
}

@State<UserStateModel>({
	name: 'user',
	defaults,
})
@Injectable()
export class UserState {
	@Action(UserAction.Update)
	add({ getState, setState }: StateContext<UserStateModel>, { payload }: UserAction.Update) {
		const state = getState()
		setState({
			...state,
			...payload,
		})
	}

	@Selector()
	static initials(state: UserStateModel): string {
		const { firstName = 'U', lastName = 'U' } = state
		return abbreviate(firstName, lastName)
	}

	@Selector()
	static crmUserId(state: UserStateModel): string {
		return state.crmUserId
	}
}
